import React from 'react'
import * as bs4 from 'reactstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from '../Navbar'
import { ScaleLoader } from 'react-spinners';
import ReactTooltip from 'react-tooltip'
import PreviewBomline from './Acc_PreviewBomLine'
import Workbook from 'react-excel-workbook'
import moment from 'moment';
import ReactGA from 'react-ga';
const { proxy } = require('../../ip_api.config')

class Acc_PreviewBomVer extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            previewIBom: '',
            isLoading: false,
            onPage: 'Preview',
            arr_temp_edit: [],
            modalPreviewBomline: false,
            id: 0,
            arrDataExcel_BomVer: [],
            arrDataExcel_BomLine: [],
            value_serach: ''
        }
    }

    componentDidMount() {
        ReactGA.initialize('UA-176717650-5');
        ReactGA.pageview('/Acc/PreviewBomVer');

        if (localStorage.getItem("ID_User") !== null) {
            this.getBom_Preview()
        } else {
            this.props.history.push({
                pathname: '/'
            })
        }
    }

    get_status_bomline = async (id) => new Promise((resolve, reject) => {
        let url = proxy.server + '/acc/get_status_bomline'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: id
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                // console.log("responseJson", responseJson)
                if (responseJson.status === 200) {
                    resolve(responseJson.result[0].QTY)
                } else {
                    resolve(0)
                }
            })
    })

    getBom_Preview = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arr = []
        let url = proxy.server + '/acc/get_bomversion'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: this.state.value_serach
            })
        })
            .then(response => response.json())
            .then(async (responseJson) => {
                console.log("responseJson", responseJson.result)
                arr = await Promise.all(responseJson.result.map(async (val, i) => {
                    let status_bomline = await this.get_status_bomline(val.id)

                    return <tr>
                        <td>{this.state.value_serach !== 'IMPORTED' && <bs4.Button color="danger" size='sm' style={{ fontSize: 14 }} onClick={() => this.Delete_bom(val.id)}>DEL</bs4.Button>}</td>
                        {
                            val.db_name === 'DPL' ?
                                <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                : val.db_name === 'DFIX' ?
                                    <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DPT' ?
                                        <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                        : ''
                        }
                        <td>{val.Active}</td>
                        <td>{val.Approved}</td>
                        <td>{val.BOM_Approved}</td>
                        <td>{val.BOM_PmfBOMFormula}</td>
                        <td>{val.BOMVersion_ApproverPersonnelNumber}</td>
                        <td>{val.BOM_BOMId}</td>
                        <td>{val.BOM_CheckBOM}</td>
                        <td>{val.BOM_ItemGroupId}</td>
                        <td>{val.BOM_Name}</td>
                        <td>{val.BOM_ApproverPersonnelNumber}</td>
                        <td>{val.Construction}</td>
                        <td>{val.InventSiteId}</td>
                        <td>{val.ItemId}</td>
                        <td>{val.Name}</td>
                        <td>
                            {
                                status_bomline === 0
                                    ? <bs4.Button color="success" style={{ fontWeight: 500, width: 170 }} onClick={() => this.openModal(val.id, val.db_name, status_bomline, val.BOM_BOMId, val.BOM_Name)}>+ ADD BOMLINE</bs4.Button>
                                    : <bs4.Button color="warning" style={{ fontWeight: 500, width: 170 }} onClick={() => this.openModal(val.id, val.db_name, status_bomline, val.BOM_BOMId, val.BOM_Name)}>PREVIEW BOMLINE</bs4.Button>
                            }
                        </td>
                    </tr>

                }, this))

                this.setState({
                    arr_save: responseJson.result, previewIBom: arr, isLoading: false, modalPreviewBomline: false,
                    arrDataExcel_BomVer: responseJson.result, fileBomVer: 'BomVersion' + moment().format('YYYYMMDD')
                }, () => {
                    this.getBom_Line()
                })
            })
    }

    getBom_Line = () => {
        this.setState({ isLoading: true, onPage: 'Preview' })
        let arr = []
        let url = proxy.server + '/acc/get_bomline'
        let last = 0
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: ''
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("get_bomline", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr style={{ textAlign: 'center' }}>
                            <td>{this.state.value_serach !== 'IMPORTED' && <bs4.Button color="danger" size='sm' onClick={() => this.onDeleteBom(val.id)}>X</bs4.Button>}</td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.BOM_Approved}</td>
                            <td>{val.BOM_ApproverPersonnelNumber}</td>
                            {/* <td>{val.BOM_PmfBOMFormula}</td>
                            <td>{val.BOM_BOMId}</td>
                            <td>{val.BOM_CheckBOM}</td>
                            <td>{val.BOM_ItemGroupId}</td>
                            <td>{val.BOM_Name}</td>
                            <td>{val.LineNum}</td> */}
                            <td>{val.ItemId}</td>
                            <td>{val.ItemDescription}</td>
                            <td>{val.BOMConsump}</td>
                            <td>{val.BOMQty}</td>
                            <td>{val.UnitId}</td>
                            <td>{val.BOMQtySerie}</td>
                            <td>{val.BOMType}</td>
                            <td>{val.Calculation}</td>
                            <td>{val.Formula}</td>
                            <td>{val.InventLocationId}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.WrkCtrConsumption}</td>
                        </tr>
                    )
                    last = val.LineNum
                }, this)
                this.setState({ isLoading: false, arrDataExcel_BomLine: responseJson.result, fileBomLine: 'BomLine' + moment().format('YYYYMMDD') })
            })
    }

    getBom_Edit = () => {
        this.setState({ modalPreviewBomline: false, isLoading: true, onPage: 'Edit' })
        let arr = []
        let url = proxy.server + '/acc/get_bomversion'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify({
                id: ''
            })
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson.result)
                responseJson.result.map(function (val, i) {
                    arr.push(
                        <tr>
                            <td style={{ justifyContent: 'center' }} data-tip="เลือกแถวที่ต้องการแก้ไข">
                                <bs4.Col>
                                    <ReactTooltip />
                                    <bs4.Input type="checkbox" style={{ width: 23, height: 23 }}
                                        onChange={(e) => this.checkbom(e.target.checked, val.id)} />
                                </bs4.Col>
                            </td>
                            {
                                val.db_name === 'DPL' ?
                                    <td style={{ backgroundColor: '#00BFFF', color: '#000' }}>{val.db_name}</td>
                                    : val.db_name === 'DFIX' ?
                                        <td style={{ backgroundColor: '#00FA9A', color: '#000' }}>{val.db_name}</td>
                                        : val.db_name === 'DPT' ?
                                            <td style={{ backgroundColor: '#fec23e', color: '#000' }}>{val.db_name}</td>
                                            : ''
                            }
                            <td>{val.Active}</td>
                            <td>{val.Approved}</td>
                            <td>{val.BOM_Approved}</td>
                            <td>{val.BOM_PmfBOMFormula}</td>
                            <td>{val.BOMVersion_ApproverPersonnelNumber}</td>
                            <td>{val.BOM_BOMId}</td>
                            <td>{val.BOM_CheckBOM}</td>
                            <td>{val.BOM_ItemGroupId}</td>
                            <td>{val.BOM_Name}</td>
                            <td>{val.BOM_ApproverPersonnelNumber}</td>
                            <td>{val.Construction}</td>
                            <td>{val.InventSiteId}</td>
                            <td>{val.ItemId}</td>
                            <td>{val.Name}</td>
                        </tr>
                    )
                }, this)
                this.setState({ previewIBom: arr, isLoading: false, modalPreviewBomline: false })
            })
    }

    checkbom = (check, id) => {
        let data = {}
        if (check === true) {
            data = {
                id: id,
            }
            let arr = this.state.arr_temp_edit.concat(data)
            this.setState({
                arr_temp_edit: arr, modalPreviewBomline: false
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        } else {
            let arr = this.state.arr_temp_edit

            for (var i = arr.length; i--;) {
                if (arr[i].id === id) arr.splice(i, 1);
            }
            this.setState({
                arr_temp_edit: arr, modalPreviewBomline: false
            }, () => {
                console.log('arr_temp_edit', this.state.arr_temp_edit)
            })
        }
    }

    goto_edit = () => {
        this.props.history.push({
            pathname: '/Acc/EditBom',
            state: { id_edit: this.state.arr_temp_edit }
        })
    }

    Delete_bom = (id) => {
        if (window.confirm("กรุณายืนยันการลบ")) {
            this.setState({ isLoading: true, modalPreviewBomline: false })
            let url = proxy.server + '/acc/delete_bomversion'
            fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json;charset=utf-8"
                },
                body: JSON.stringify({
                    id: id,
                })
            })
                .then(response => response.json())
                .then((responseJson) => {
                    console.log("responseJson", responseJson)
                    if (responseJson.status === 201) {
                        this.setState({ isLoading: false }, () => {
                            alert('ลบสำเร็จ')
                            this.getBom_Preview()
                        })
                    } else {
                        this.setState({ isLoading: false }, () => {
                            alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                        })
                    }
                })
        }
    }

    openModal = (id, db_name, status_bomline, bom_no, bom_description) => {
        this.setState({
            db_name: db_name,
            id: id,
            status: status_bomline,
            bom_no: bom_no,
            bom_description: bom_description,
            modalPreviewBomline: true
        })
    }

    handleClose = () => {
        this.setState({
            modalPreviewBomline: false,
        }, () => { this.getBom_Preview() })
    }

    // savetoAX = () => {
    //     if (window.confirm("กรุณายืนยันการบันทึกเข้า AX")) {
    //         this.setState({ isLoading: true })
    //         let url = proxy.server + '/Acc/insertBomver_itemToAX'
    //         fetch(url, {
    //             method: "POST",
    //             headers: {
    //                 Accept: "application/json",
    //                 "Content-Type": "application/json;charset=utf-8"
    //             },
    //             body: JSON.stringify(this.state.arr_save)
    //         })
    //             .then(response => response.json())
    //             .then((responseJson) => {
    //                 console.log("responseJson", responseJson)
    //                 if (responseJson.status === 201) {
    //                     this.setState({ isLoading: false }, () => {
    //                         alert('บันทึกสำเร็จ')
    //                         this.getBom_Preview()
    //                     })
    //                 } else {
    //                     this.setState({ isLoading: false }, () => {
    //                         alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
    //                     })
    //                 }
    //             })
    //     }
    // }

    savetoAX = () => {
        // console.log('arr_save', this.state.arr_save)
        let arr_dpl = this.state.arr_save.filter(x => x.db_name === 'DPL')
        if (arr_dpl.length === 0) {
            alert('ไม่มี Item DPL ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPL จำนวน ${arr_dpl.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/Acc/insertBomver_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpl)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getBom_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }

    savetoAXDPT = () => {
        let arr_dpt = this.state.arr_save.filter(x => x.db_name === 'DPT')
        if (arr_dpt.length === 0) {
            alert('ไม่มี Item DPT ให้ import')
        } else {
            if (window.confirm(`กรุณายืนยันการบันทึกเข้า AX DPT จำนวน ${arr_dpt.length} รายการ`)) {
                this.setState({ isLoading: true })
                let url = proxy.server + '/Acc/dpt/insertBomver_itemToAX'
                fetch(url, {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    body: JSON.stringify(arr_dpt)
                })
                    .then(response => response.json())
                    .then((responseJson) => {
                        console.log("responseJson", responseJson)
                        if (responseJson.status === 201) {
                            this.setState({ isLoading: false }, () => {
                                alert('บันทึกสำเร็จ')
                                this.getBom_Preview()
                            })
                        } else {
                            this.setState({ isLoading: false }, () => {
                                alert('ไม่สามารถบันทึกข้อมูลได้ กรุณาตรวจสอบข้อมูล')
                            })
                        }
                    })
            }
        }
    }

    render() {
        return <div>
            <Navbar nav={'Acc'} menu={'Acc_PreviewBomVer'} />
            <div style={{ marginLeft: 20, marginTop: 50, marginRight: 10 }}>
                <bs4.FormGroup row style={{ marginLeft: 10, marginBottom: 5 }}>
                    <bs4.Col sm='4'>
                        <bs4.Input type='select' onChange={(e) => this.setState({ value_serach: e.target.value }, () => { this.getBom_Preview() })}>
                            <option value=''>CREATED</option>
                            <option value='IMPORTED'>IMPORTED</option>
                        </bs4.Input>
                    </bs4.Col>
                    {
                        this.state.value_serach !== 'IMPORTED'
                            ? this.state.onPage === 'Preview'
                                ? <div>
                                    <bs4.Button color="secondary" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.getBom_Edit()}>EDIT</bs4.Button>
                                    <bs4.Button color="primary" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAX()}>IMPORT TO DPL</bs4.Button>
                                    <bs4.Button color="success" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.savetoAXDPT()}>IMPORT TO DPT</bs4.Button>
                                </div>
                                : <div>
                                    <bs4.Button color="warning" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 150 }} onClick={() => this.goto_edit()}>GO TO EDIT</bs4.Button>
                                    <bs4.Button color="secondary" style={{ fontSize: 16, fontWeight: 500, width: 150, marginRight: 20 }} onClick={() => this.getBom_Preview()}>CANCEL</bs4.Button>
                                </div>
                            : ''
                    }
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                    <ScaleLoader
                        size={15}
                        loading={this.state.isLoading}
                    />
                </bs4.FormGroup>
                <br />
                <bs4.FormGroup row style={{ marginLeft: 25, marginBottom: 5 }}>
                    <Workbook filename={this.state.fileBomVer + '.xlsx'} element={<bs4.Button outline color="secondary" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 300 }}>EXPORT EXCEL BOMVERSION</bs4.Button>} >
                        <Workbook.Sheet data={this.state.arrDataExcel_BomVer} name="sheet1">
                            {/* <Workbook.Column label="db_name" value="db_name" /> */}
                            <Workbook.Column label="Active" value="Active" />
                            <Workbook.Column label="Approved" value="Approved" />
                            <Workbook.Column label="BOM_Approved" value="BOM_Approved" />
                            <Workbook.Column label="BOM_PmfBOMFormula" value="BOM_PmfBOMFormula" />
                            <Workbook.Column label="BOMVersion_ApproverPersonnelNumber" value="BOMVersion_ApproverPersonnelNumber" />
                            <Workbook.Column label="BOM_BOMId" value="BOM_BOMId" />
                            <Workbook.Column label="BOM_CheckBOM" value="BOM_CheckBOM" />
                            <Workbook.Column label="BOM_ItemGroupId" value="BOM_ItemGroupId" />
                            <Workbook.Column label="BOM_Name" value="BOM_Name" />
                            <Workbook.Column label="BOM_ApproverPersonnelNumber" value="BOM_ApproverPersonnelNumber" />
                            <Workbook.Column label="Construction" value="Construction" />
                            <Workbook.Column label="InventSiteId" value="InventSiteId" />
                            <Workbook.Column label="ItemId" value="ItemId" />
                            <Workbook.Column label="Name" value="Name" />
                        </Workbook.Sheet>
                    </Workbook>
                    <Workbook filename={this.state.fileBomLine + '.xlsx'} element={<bs4.Button outline color="secondary" style={{ fontSize: 16, fontWeight: 500, marginRight: 20, width: 300 }}>EXPORT EXCEL BOMLINE</bs4.Button>} >
                        <Workbook.Sheet data={this.state.arrDataExcel_BomLine} name="sheet1">
                            {/* <Workbook.Column label="db_name" value="db_name" /> */}
                            <Workbook.Column label="BOM_Approved" value="BOM_Approved" />
                            <Workbook.Column label="BOM_ApproverPersonnelNumber" value="BOM_ApproverPersonnelNumber" />
                            <Workbook.Column label="BOM_PmfBOMFormula" value="BOM_PmfBOMFormula" />
                            <Workbook.Column label="BOM_BOMId" value="BOM_BOMId" />
                            <Workbook.Column label="BOM_CheckBOM" value="BOM_CheckBOM" />
                            <Workbook.Column label="BOM_ItemGroupId" value="BOM_ItemGroupId" />
                            <Workbook.Column label="BOM_Name" value="BOM_Name" />
                            <Workbook.Column label="LineNum" value="LineNum" />
                            <Workbook.Column label="ItemId" value="ItemId" />
                            <Workbook.Column label="ItemDescription" value="ItemId_description" />
                            <Workbook.Column label="BOMConsump" value="BOMConsump" />
                            <Workbook.Column label="BOMQty" value="BOMQty" />
                            <Workbook.Column label="UnitId" value="UnitId" />
                            <Workbook.Column label="BOMQtySerie" value="BOMQtySerie" />
                            <Workbook.Column label="BOMType" value="BOMType" />
                            <Workbook.Column label="Calculation" value="Calculation" />
                            <Workbook.Column label="Formula" value="Formula" />
                            <Workbook.Column label="InventLocationId" value="InventLocationId" />
                            <Workbook.Column label="InventSiteId" value="InventSiteId" />
                            <Workbook.Column label="WrkCtrConsumption" value="WrkCtrConsumption" />
                        </Workbook.Sheet>
                    </Workbook>
                </bs4.FormGroup>
                <br />
                <bs4.Table bordered hover style={{ fontSize: 15 }}>
                    <thead style={{ backgroundColor: '#8f8f8f', color: '#000' }}>
                        <tr style={{ textAlign: 'center' }}>
                            <th></th>
                            <th>ฐานข้อมูล</th>
                            <th>Active</th>
                            <th>Approved</th>
                            <th>BOM_<br />Approved</th>
                            <th>BOM_<br />PmfBOM<br />Formula</th>
                            <th>BOM<br />Version_<br />Approver<br />Personnel<br />Number</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>BOM_BOMId</th>
                            <th>BOM_<br />Check<br />BOM</th>
                            <th>BOM_<br />Item<br />GroupId</th>
                            <th style={{ backgroundColor: '#fec23e', color: '#000' }}>BOM_Name</th>
                            <th>BOM_<br />Approver<br />Personnel<br />Number</th>
                            <th>Construction</th>
                            <th>InventSiteId</th>
                            <th>ItemId</th>
                            <th>Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.previewIBom}
                    </tbody>
                </bs4.Table>
            </div>

            <PreviewBomline open={this.state.modalPreviewBomline} id={this.state.id} db_name={this.state.db_name} status={this.state.status} bom_no={this.state.bom_no} bom_description={this.state.bom_description} go={this.props.history} value_serach={this.state.value_serach} handleClose={() => this.handleClose()} />
        </div>
    }
}

export default Acc_PreviewBomVer